const WA_URL = "https://wa.me/918904182425?text=Hi%20Branded%20by%20Knowfinity!%20I'd%20like%20a%20free%20growth%20audit%20for%20my%20brand.";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm0 18.03c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.23 8.23zm4.52-6.16c-.25-.13-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.13-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.13-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.13.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.29z"/>
  </svg>
);

export const WhatsAppButton = () => (
  <a
    href={WA_URL}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat with us on WhatsApp"
    className="group fixed bottom-6 right-6 z-40 flex items-center gap-0 rounded-full bg-[#25D366] p-4 text-black shadow-[0_8px_32px_rgba(37,211,102,0.35)] transition-all duration-300 hover:shadow-[0_8px_44px_rgba(37,211,102,0.55)] hover:scale-105"
  >
    <WhatsAppIcon />
    <span className="max-w-0 overflow-hidden whitespace-nowrap font-mono2 text-xs font-bold tracking-[0.1em] uppercase opacity-0 transition-all duration-500 group-hover:max-w-[140px] group-hover:opacity-100 group-hover:pl-2.5">
      Chat with us
    </span>
  </a>
);
